import { createContext, useContext } from 'react';

export type BillingMode = 'monthly' | 'yearly';

type Ctx = {
  mode: BillingMode;
  setMode: (m: BillingMode) => void;
};

export const PricingContext = createContext<Ctx | null>(null);

export function usePricingMode() {
  const ctx = useContext(PricingContext);
  if (!ctx) throw new Error('usePricingMode must be used within PricingContext.Provider');
  return ctx;
}
